export enum OverlayType {
    ERROR = 'error',
    ERROREMPTY = 'empty-data',
    ERROR_MATCH = 'error_match',
    MATCH_TICKET = 'match-ticket',
    NO_MATCH = 'no-match',
}
